module.exports = __webpack_public_path__ + "static/media/flag-deemed.1a3632aa.svg";